@let authorization = authorization$ | async;

<pds-form [formGroup]="form">
  @if(!authorization?.data){
  <pds-form-row grid="1-1">
    <pds-form-field label="Client ID">
      <input type="text" formControlName="clientId" placeholder="store-pecaai" />
    </pds-form-field>
    <pds-form-field label="Client Secret">
      <input type="password" formControlName="clientSecret" placeholder="********************" />
    </pds-form-field>
  </pds-form-row>
  }@else {
  <pds-form-row>
    <pds-form-field label="Credencial">
      <input type="text" [value]="authorization?.data | credentials" readonly disabled />
    </pds-form-field>
  </pds-form-row>
  }
  <pds-form-actions>
    @if (!authorization?.data) {
    <button pdsButton (click)="onClickAuthorize()" [disabled]="form.disabled">Autorizar</button>
    } @else {
    <button pdsButton="primary" (click)="onClickClear()">Limpar sessão</button>
    }
  </pds-form-actions>
</pds-form>
